import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { BoxLabel as BoxHeader } from '../Styled'
import { BoxListContent, BoxCard } from '../Details/Styled'

import { checkEmpty } from './events'

export const BoxLabel = ({ labelTop, labelBottom }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body1" color="text.secondary" sx={{ width: 280 }}>
        {labelTop}
      </Typography>
      <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
        {labelBottom}
      </Typography>
    </Box>
  )
}

const Index = ({ data }) => {

  return (
    <BoxCard>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', p: 3, width: '100%' }}
      >
        <BoxHeader>
          <Typography variant="h6" color="primary.main" sx={{ mb: 1 }}>
            ประสบการณ์
          </Typography>
        </BoxHeader>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <BoxListContent>
            <BoxLabel
              labelTop="สถานศึกษา (มหาวิทยาลัย)"
              labelBottom={checkEmpty(data, 'institution')}
            />
          </BoxListContent>
          <BoxListContent>
            <BoxLabel
              labelTop="ระหว่างปี"
              labelBottom={checkEmpty(data, 'between')}
            />
            <BoxLabel
              labelTop="วุฒิการศึกษา"
              labelBottom={checkEmpty(data, 'qualificationName')}
            />
          </BoxListContent>
          <BoxListContent>
            <BoxLabel
              labelTop="สาขา"
              labelBottom={checkEmpty(data, 'branch')}
            />
            <BoxLabel
              labelTop="เกรดเฉลี่ย"
              labelBottom={checkEmpty(data, 'gpa')}
            />
          </BoxListContent>
        </Box>
      </Box>
    </BoxCard>
  )
}
export default Index
